<script lang="ts">
  import DataTable, { Head, Body, Row, Cell, Label } from "@smui/data-table";
  import IconButton, { Icon } from "@smui/icon-button";
  import { mdiPencilBoxOutline, mdiCartPlus } from "@mdi/js";
  import Flex from "svelte-flex";
  import { _ } from "svelte-i18n";

  import { createEventDispatcher } from "svelte";

  import PsEditPriceCell from "./PsEditPriceCell.svelte";
  import PsEditLogisticsCell from "./PsEditLogisticsCell.svelte";
  import { appParameters } from "../../../stores/AppConfig";
    import { validateOnlyOfferInd } from "../Upload/ValidateQuoteSheet";

  // Items
  export let screen = "PS";
  export let items: Items[] = [];
  export let product = {};
  export let filter = [];
  export let hideBuyIcon = false;
  export let hideEditIcon = false;
  export let purchasedSuppliers = [];
  export let proposedPurchaseVolume = [];
  export let country = [];
  export let editDisabled = false;
  export let showOnlyOfferRows= true;

  type Items = {
    qsId: number;
    quoteSheetId: number;
    supplierId: number;
    supplierName: string;
    country: string;
    currency: string;
    variety: number;
    countryOfOrigin: number;
    lwCountryOfOrigin: number;
    lyCountryOfOrigin: number;
    cartonLogistics: number;
    palletLogistics: number;
    lwCartonLogistics: number;
    lwPalletLogistics: number;
    participation: number;
    volume: number;
    volume1w: number;
    volume1y: number;
    remainingVolume: number;
    units: string;
    cartonVolume: number;
    palletVolume: number;
    price: number;
    priceEur: number;
    priceEurLW: number;
    priceEurLY: number;
    priceLW: number;
    priceLY: number;
    pricePromo: number;
    pricePromoEur: number;
    onlyOfferInd: number;


  };
  const dispatch = createEventDispatcher();
</script>

<DataTable table$aria-label="Quote Sheets table" class="w-100 mt-2">
  <Head>
    <Row>
      <Cell rowspan="2" columnId="actions" class="datatable-header pl-0 pr-0 sticky-col">
        <Label></Label>
      </Cell>
      <Cell rowspan="2" columnId="supplierId" class="datatable-header right-splitter-sub">
        <Label>{$_("supplier")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="supplierName" class="datatable-header right-splitter-sub">
        <Label>{$_("supplier_name")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="country" class="datatable-header right-splitter-sub">
        <Label>{$_("country")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="currency" class="datatable-header right-splitter-sub">
        <Label>{$_("currency")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="variety" class="datatable-header right-splitter-sub">
        <Label>{$_("variety")}</Label>
      </Cell>
      <Cell colspan="3" columnId="countryOfOrigin" class="datatable-header text-center wrap-spaces right-splitter-sub bottom-splitter-sub">
        <Label>{$_("country_of_origin")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="cartonLogistics" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("carton_logistics")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="palletLogistics" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("pallet_logistics")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="volume" class="datatable-header right-splitter-sub wrap-spaces">
        <Label>{$_("volume")} <small>{$_("participation")}</small></Label>
      </Cell>
      <Cell rowspan="2" columnId="remainingVolume" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("remaining_volume")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="units" class="datatable-header right-splitter-sub">
        <Label>{$_("units")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="cartonVolume" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("carton_volume")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="palletVolume" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("pallet_volume")}</Label>
      </Cell>
      <Cell colspan="3" columnId="price" class="datatable-header text-center wrap-spaces right-splitter-sub bottom-splitter-sub">
        <Label>{$_("offered_price")}</Label>
      </Cell>
      <Cell rowspan="2" columnId="pricePromo" class="datatable-header text-center wrap-spaces right-splitter-sub bottom-splitter-sub">
        <Label>{$_("offered_price_promo")}</Label>
      </Cell>
    </Row>
    <Row>
      <Cell columnId="countryOfOrigin" class="datatable-header text-center wrap-spaces right-splitter-sub no-border-radius">
        <Label>{$_("cur")}</Label>
      </Cell>
      <Cell columnId="lwCountryOfOrigin" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("lw")}</Label>
      </Cell>
      <Cell columnId="lyCountryOfOrigin" class="datatable-header text-center wrap-spaces right-splitter-sub no-border-radius">
        <Label>{$_("ly")}</Label>
      </Cell>
      <Cell columnId="price" class="datatable-header text-center wrap-spaces right-splitter-sub no-border-radius">
        <Label>{$_("cur")}</Label>
      </Cell>
      <Cell columnId="price1w" class="datatable-header text-center wrap-spaces right-splitter-sub">
        <Label>{$_("lw")}</Label>
      </Cell>
      <Cell columnId="price1y" class="datatable-header text-center wrap-spaces right-splitter-sub no-border-radius">
        <Label>{$_("ly")}</Label>
      </Cell>
    </Row>
  </Head>
  <Body>
    {#if items.length == 0 || (items.length > 0 && items.filter((i) => (filter.length == 0 || filter.includes(i.country)) && (!country || country.length == 0 || country.includes(i.country))).length == 0)}
      <Row>
        <td colspan="18" class="mdc-data-table__cell text-center" style="width: 100%">{$_("no_data")}</td>
      </Row>
    {:else}
      {#each items
        .filter((i) => (filter.length == 0 || filter.includes(i.country)) && (showOnlyOfferRows || i.onlyOfferInd == 0))
        .sort((a, b) => ([a.country[0].replace("C", "1").replace("S", "2").replace("H", "3"), a.onlyOfferInd, a.supplierName.toLowerCase()].join(":") > [b.country[0]
              .replace("C", "1")
              .replace("S", "2")
              .replace("H", "3"), b.onlyOfferInd, b.supplierName.toLowerCase()].join(":") ? 1 : -1)) as item (item.id)}
        {#if (country && country.length > 0 && country.includes(item.country)) || !country || country.length == 0}
          {@const itemPurchasedVolume = proposedPurchaseVolume.filter((x) => x.quoteSheetId == item.qsId && x.supplierId == item.supplierId).at(0)?.totalVol || 0}
          {@const remainingVolume = item.remainingVolume - itemPurchasedVolume}
          {@const logParam = $appParameters["logistics_equal_" + item.country.toLowerCase()]?.value}

          <Row>
            <Cell class="pl-0 pr-0 sticky-col">
              <Flex direction="row">
                {#if !hideBuyIcon && purchasedSuppliers.filter((x) => x.supplierId == item.supplierId).length == 0}
                  <div title={$_("buy")}>
                    <IconButton data-qa="ps-qs-row-buy-{item.supplierId}-btn" size="button" class="tescoblue-text opacity-1" on:click={() => dispatch("newPurchase", { ...item })}>
                      <Icon tag="svg" viewBox="0 0 24 24" class="tescoblue-text">
                        <path fill="currentColor" d={mdiCartPlus} />
                      </Icon>
                    </IconButton>
                  </div>
                {/if}
                {#if !hideEditIcon}
                  <div title={$_("edit")}>
                    <IconButton
                      data-qa="ps-qs-row-edit-{item.supplierId}-btn"
                      size="button"
                      class="tescoblue-text opacity-1"
                      on:click={() => dispatch("editQuoteSheetRow", { ...item })}
                    >
                      <Icon tag="svg" viewBox="0 0 24 24" class="tescoblue-text">
                        <path fill="currentColor" d={mdiPencilBoxOutline} />
                      </Icon>
                    </IconButton>
                  </div>
                {/if}
              </Flex>
            </Cell>
            <Cell class="right-splitter-sub">{item.supplierId}</Cell>
            <Cell class="right-splitter-sub">{item.supplierName}</Cell>
            <Cell class="right-splitter-sub text-center">{item.country}</Cell>
            <Cell class="right-splitter-sub text-center">{item.currency}</Cell>
            <Cell class="right-splitter-sub">{item.variety ? item.variety : ""}</Cell>
            <Cell class="right-splitter-sub text-center text-bold">{item.countryOfOrigin}</Cell>
            <Cell class="right-splitter-sub text-center">{item.lwCountryOfOrigin}</Cell>
            <Cell class="right-splitter-sub text-center">{item.lyCountryOfOrigin}</Cell>
            {#if screen == "PS"}
              <!-- Table is called from main Purchase screen -->
              <Cell class="right-splitter-sub" numeric>
                {#if ["ALL", "CART"].includes(logParam) && item.lwCartonLogistics && item.cartonLogistics != item.lwCartonLogistics}
                  <span class="red lighten-3 pa-2" title={$_("lw") + ": " + item.lwCartonLogistics}>
                    {item.cartonLogistics}
                  </span>
                  &nbsp;{item.origCartonLogistics != item.cartonLogistics ? "(" + item.origCartonLogistics + ")" : ""}
                {:else if ["ALL", "CART"].includes(logParam) && product.cartonLogistics && item.cartonLogistics != product.cartonLogistics}
                  <span class="yellow lighten-2 pa-2" title={$_("product") + ": " + product.cartonLogistics}>
                    {item.cartonLogistics}
                  </span>
                  &nbsp;{item.origCartonLogistics != item.cartonLogistics ? "(" + item.origCartonLogistics + ")" : ""}
                {:else}
                  {item.cartonLogistics} &nbsp; {item.origCartonLogistics != item.cartonLogistics ? "(" + item.origCartonLogistics + ")" : ""}
                {/if}
              </Cell>
              <Cell class="right-splitter-sub" numeric>
                {#if ["ALL", "PAL"].includes(logParam) && item.lwPalletLogistics && item.palletLogistics != item.lwPalletLogistics}
                  <span class="red lighten-3 pa-2" title={$_("lw") + ": " + item.lwPalletLogistics}>
                    {item.palletLogistics}
                  </span>
                  &nbsp;{item.origPalletLogistics != item.palletLogistics ? "(" + item.origPalletLogistics + ")" : ""}
                {:else if ["ALL", "PAL"].includes(logParam) && product.palletLogistics && item.palletLogistics != product.palletLogistics}
                  <span class="yellow lighten-2 pa-2" title={$_("product") + ": " + product.palletLogistics}>
                    {item.palletLogistics}
                  </span>
                  &nbsp;{item.origPalletLogistics != item.palletLogistics ? "(" + item.origPalletLogistics + ")" : ""}
                {:else}
                  {item.palletLogistics} &nbsp; {item.origPalletLogistics != item.palletLogistics ? "(" + item.origPalletLogistics + ")" : ""}
                {/if}
              </Cell>
            {:else}
              <PsEditLogisticsCell
                value={item.purchaseCartonLogistics ?? null}
                rowStyle={""}
                type={"carton"}
                logisticsCheckType={logParam}
                purchaseLogistics={item.purchaseCartonLogistics}
                productLogistics={product.cartonLogistics}
                qsLogistics={item.cartonLogistics}
                lwLogistics={item.lwCartonLogistics}
                {editDisabled}
                on:startEdit={() => {
                  editDisabled = true;
                }}
                on:finishEdit={() => {
                  editDisabled = false;
                }}
                on:valueChanged={(e) => dispatch("qsLogisticsChanged", { item: item, logistics: Number(e.detail.value), type: "carton" })}
              />
              <PsEditLogisticsCell
                value={item.purchasePalletLogistics ?? null}
                rowStyle={""}
                type={"pallet"}
                logisticsCheckType={logParam}
                purchaseLogistics={item.purchasePalletLogistics}
                productLogistics={product.palletLogistics}
                qsLogistics={item.palletLogistics}
                lwLogistics={item.lwPalletLogistics}
                {editDisabled}
                on:startEdit={() => {
                  editDisabled = true;
                }}
                on:finishEdit={() => {
                  editDisabled = false;
                }}
                on:valueChanged={(e) => dispatch("qsLogisticsChanged", { item: item, logistics: Number(e.detail.value), type: "pallet" })}
              />
            {/if}
            <Cell class="right-splitter-sub" numeric>{item.volume}<br /><small>({item.participation} %)</small></Cell>
            <Cell class="right-splitter-sub" numeric
              ><span class="font-weight-bold {item.remainingVolume == 0 ? 'tescored-text' : 'tescoblue-text'}">{item.remainingVolume}</span>
            </Cell>
            <Cell class="right-splitter-sub text-center">{item.units}</Cell>
            <Cell class="right-splitter-sub" numeric>{item.cartonVolume}</Cell>
            <Cell class="right-splitter-sub" numeric>{item.palletVolume}</Cell>
            {#if screen == "PS"}
              <!-- Table is called from main Purchase screen => Standard Price cell -->
              <Cell class="right-splitter-sub text-right">
                <span class="price {item.onlyOfferInd == 1 ? 'orange-text': 'black-text'}">
                  <span class=" text-bold text-end">{item.price}</span> <br />
                  <div>
                    <small><span>{item.priceEur} EUR</span></small>
                  </div>
                </span>
              </Cell>
            {:else}
              <!-- Table is called from Purchase popup => Editable Price cell -->
              <PsEditPriceCell
                value={item.price ?? null}
                valueConv={item.priceEur ?? null}
                writable={true}
                rowStyle={""}
                currency={item.currency}
                type="promo"
                {editDisabled}
                on:startEdit={() => {
                  editDisabled = true;
                }}
                on:finishEdit={() => {
                  editDisabled = false;
                }}
                on:valueChanged={(e) => dispatch("qsPriceChanged", { item: item, price: Number(e.detail.value), priceEur: Number(e.detail.valueConv), type: "regular" })}
              />
            {/if}
            <Cell class="right-splitter-sub text-right">
              {#if item.priceLW}
                <span class="text-end">{item.priceLW}</span>
                {#if item.priceEurLW > 0}
                  <br />
                  <div class="grey-text">
                    <small><span>{item.priceEurLW} EUR</span></small>
                  </div>
                {/if}
              {/if}
            </Cell>
            <Cell class="right-splitter-sub text-right">
              {#if item.priceLY}
                <span class="text-end">{item.priceLY}</span>
                {#if item.priceEurLY > 0}
                  <br />
                  <div class="grey-text">
                    <small><span>{item.priceEurLY} EUR</span></small>
                  </div>
                {/if}
              {/if}
            </Cell>
            {#if screen == "PS"}
              <!-- Table is called from main Purchase screen => Standard Promo Price cell -->
              <Cell class="text-right black-text">
                <span class="price {item.onlyOfferInd == 1 ? 'orange-text': 'black-text'}">
                  {#if item.pricePromo}
                    <span class=" text-bold text-end">{item.pricePromo}</span>
                    <br />
                    <div>
                      <small><span>{item.pricePromoEur} EUR</span></small>
                    </div>
                  {/if}
                </span>
              </Cell>
            {:else}
              <!-- Table is called from Purchase popup => Editable Promo Price cell -->
              <PsEditPriceCell
                value={item.pricePromo ?? null}
                valueConv={item.pricePromoEur ?? null}
                writable={true}
                rowStyle={""}
                currency={item.currency}
                type="promo"
                {editDisabled}
                on:startEdit={() => {
                  editDisabled = true;
                }}
                on:finishEdit={() => {
                  editDisabled = false;
                }}
                on:valueChanged={(e) => dispatch("qsPriceChanged", { item: item, price: Number(e.detail.value), priceEur: Number(e.detail.valueConv), type: "promo" })}
              />
            {/if}
          </Row>
        {/if}
      {/each}
    {/if}
  </Body>
</DataTable>
